// extracted by mini-css-extract-plugin
export default {"tooltipMobile":"TooltipComponent_tooltipMobile__yNaiI"};